import { EventSourceHandler } from '@sellsy/sse';

export default class EmailVerificationEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.email.verification';
    }

    handle(event) {
        if (event.type === 'staff.email.verification') {
            const success = event.data.type !== 'error';
            EventBus.emit('email:onEmailVerified', {
                success: success,
                message: event.data.message,
                senderEmail: event.data.sender,
            });
        }
    }
}
